import classnames from 'classnames';
import React, { FunctionComponent } from 'react';

type CouchLampProps = {
    className?: string;
};

const CouchLamp: FunctionComponent<CouchLampProps> = props => {
    return (
        <svg
            className={classnames('dibsIcon', props.className)}
            data-tn={'couch-lamp'}
            viewBox="0 0 250 250"
        >
            <path d="M162.6 167.4h-1.9v-14.5c0-8-6.5-14.5-14.5-14.5H30.3c-8 0-14.5 6.5-14.5 14.5v14.5H14c-8 0-14.5 6.5-14.5 14.5v40.3c0 8 6.5 14.5 14.5 14.5h5.2V250h5v-13.4H150V250h5v-13.4h7.5c8 0 14.5-6.5 14.5-14.5v-40.3c.1-7.9-6.4-14.4-14.4-14.4zm-16.4-24c5.2 0 9.5 4.3 9.5 9.5v14.5h-1.1c-8 0-14.5 6.5-14.5 14.5v17.7H90.8v-56.2h55.4zm-125.4 9.5c0-5.2 4.3-9.5 9.5-9.5h55.4v56.2H36.5v-17.7c0-8-6.5-14.5-14.5-14.5h-1.1v-14.5zm151.3 69.2c0 5.2-4.3 9.5-9.5 9.5h-8c-.3 0-.7 0-1-.1H23.1c-.4 0-.7.1-1 .1h-8c-5.2 0-9.5-4.3-9.5-9.5v-40.3c0-5.2 4.3-9.5 9.5-9.5h8c5.2 0 9.5 4.3 9.5 9.5v22.7h113.6v-22.7c0-5.2 4.3-9.5 9.5-9.5h8c5.2 0 9.5 4.3 9.5 9.5v40.3z" />
            <path d="M239.5 42.7c-.8-4.8-3.8-7.6-8-7.6h-49.9c-4.4 0-8.4 3.4-8.9 7.6l-10.1 55.7v.4c0 4.4 3.6 8 8 8H204v137.8h-18.8v5h42.5v-5H209V106.9h33.5c4.4 0 8-3.6 8-8v-.2l-11-56zm3 59.2h-71.9c-1.6 0-2.9-1.2-3-2.8l10.1-55.5v-.1c.2-1.8 2.1-3.3 4-3.3h49.9c.7 0 2.5 0 3.1 3.5l11 55.4c-.3 1.5-1.6 2.8-3.2 2.8z" />
        </svg>
    );
};
export default CouchLamp;
